import { enqueueSnackbar, UploadFile, DownloadFile } from 'actions';

import {
	GetTicketsRequest,
	GetActivitiesRequest,
	GetTeamsByTypeRequest,
	GetTypesRequest,
	AddTicketRequest,
	GetTicketRequest,
	AddCommentRequest,
	AddAttachedFileRequest,
	DeleteTicketRequest,
	DeleteAttachFileRequest,
	GetStagesRequest,
	EditTicketRequest
} from '../requests/TicketsRequets.js';

export const TOGGLE_ADD_TICKET_DIALOG = 'TOGGLE_ADD_TICKET_DIALOG';
export const TOGGLE_FILTERS = 'TOGGLE_FILTERS';
export const SET_FORM_STATE = 'SET_FORM_STATE';
export const GET_TICKET = 'GET_TICKET';
export const GET_TICKETS = 'GET_TICKETS';
export const GET_TEAMS_BY_TYPE = 'GET_TEAMS_BY_TYPE';
export const GET_ACTIVITIES = 'GET_ACTIVITIES';
export const GET_TYPES = 'GET_TYPES';
export const GET_STAGES = 'GET_STAGES';

const onToggleAddTicketDialog = (openAddTicketDialog) => ({
	type: TOGGLE_ADD_TICKET_DIALOG,
	openAddTicketDialog,
});

const onToggleFilters = (openFilters) => ({
	type: TOGGLE_FILTERS,
	openFilters,
});

const onSetFormState = (formState) => ({
	type: SET_FORM_STATE,
	formState
});

const onGetTicket = (ticket) => ({
	type: GET_TICKET,
	ticket
});

const onGetTickets = (tickets) => ({
	type: GET_TICKETS,
	tickets
});

const onGetTeamsByType = (teams) => ({
	type: GET_TEAMS_BY_TYPE,
	teams
});

const onGetActivities = (activities) => ({
	type: GET_ACTIVITIES,
	activities
});

const onGetTypes = (types) => ({
	type: GET_TYPES,
	types
});

const onGetStages = (stages) => ({
	type: GET_STAGES,
	stages
});

export const ToggleAddTicketDialog = (openAddTicketDialog) => (dispatch) => {
	dispatch(onToggleAddTicketDialog(openAddTicketDialog));
};

export const ToggleFilters = (openFilters) => (dispatch) => {
	dispatch(onToggleFilters(openFilters));
};

export const SetFormState = (value) => (dispatch) => {
	dispatch(onSetFormState(value));
};

export const GetTicket = (ticketId) => async (dispatch) => {
	await GetTicketRequest(ticketId).then(response => {
		dispatch(onGetTicket(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetTickets = (close, activeStage) => async (dispatch) => {
	await GetTicketsRequest(close, activeStage).then(response => {
		dispatch(onGetTickets(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetTeamsByType = (typeId, active) => async (dispatch) => {
	await GetTeamsByTypeRequest(typeId, active).then(response => {
		dispatch(onGetTeamsByType(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetTypes = (activityId, active) => async (dispatch) => {
	await GetTypesRequest(activityId, active).then(response => {
		dispatch(onGetTypes(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetActivities = (active) => async (dispatch) => {
	await GetActivitiesRequest(active).then(response => {
		dispatch(onGetActivities(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const AddTicket = (ticket) => async (dispatch) => {
	await AddTicketRequest(ticket).then(response => {
		dispatch(GetTickets(0, 1));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const AddAttachedFile = (ticketId, fileName, userId) => async (dispatch) => {
	await AddAttachedFileRequest(ticketId, fileName, userId).then(response => {
		dispatch(GetTicket(ticketId));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const AddComment = (ticketId, userId, comment) => async (dispatch) => {
	await AddCommentRequest(ticketId, userId, comment).then(response => {
		dispatch(GetTicket(ticketId));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const DeleteTicket = (ticketId) => async (dispatch) => {
	await DeleteTicketRequest(ticketId).then(response => {
		dispatch(GetTickets(0, 1));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const DeleteAttachFile = (ticketId, ticketFileId, userId) => async (dispatch) => {
	await DeleteAttachFileRequest(ticketFileId, userId).then(response => {
		dispatch(GetTicket(ticketId));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetStages = (currentStageId, active) => async (dispatch) => {
	await GetStagesRequest(currentStageId, active).then(response => {
		dispatch(onGetStages(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const EditTicket = (ticket) => async (dispatch) => {
	await EditTicketRequest(ticket).then(response => {
		dispatch(GetTicket(ticket.id));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};
